import { cmsPlainText } from "../components/common/CmsRichText";



function normalizeHref(href) {

  if (typeof href !== "string") {

    return "";

  }



  const value = href.trim();

  if (!value || value === "#" || value.toLowerCase() === "javascript:void(0)") {

    return "";

  }



  return value;

}



export function resolveFooterContactHref(type, displayValue, explicitHref) {

  const href = normalizeHref(explicitHref);



  if (href) {

    return href;

  }



  const text = cmsPlainText(displayValue);



  switch (type) {

    case "phone": {

      const digits = text.replace(/[^\d+]/g, "");

      return digits ? `tel:${digits}` : "";

    }

    case "email":

      return text.includes("@") ? `mailto:${text}` : "";

    case "instagram": {

      const handle = text.replace(/^@/, "").trim();

      return handle ? `https://www.instagram.com/${handle}` : "";

    }

    case "twitter": {

      const handle = text.replace(/^@/, "").trim();

      return handle ? `https://twitter.com/${handle}` : "";

    }

    default:

      return "";

  }

}



export function buildFooterContactItems(contact = {}) {

  return [

    {

      type: "phone",

      iconKey: "phone",

      value: contact.phone,

      href: resolveFooterContactHref("phone", contact.phone, contact.phoneHref),

    },

    {

      type: "email",

      iconKey: "email",

      value: contact.email,

      href: resolveFooterContactHref("email", contact.email, contact.emailHref),

    },

    {

      type: "instagram",

      iconKey: "instagram",

      value: contact.instagram,

      href: resolveFooterContactHref(

        "instagram",

        contact.instagram,

        contact.instagramHref

      ),

    },

    {

      type: "twitter",

      iconKey: "twitter",

      value: contact.twitter,

      href: resolveFooterContactHref("twitter", contact.twitter, contact.twitterHref),

    },

  ].filter((item) => cmsPlainText(item.value));

}



export function isExternalFooterHref(href) {

  return /^https?:\/\//i.test(href || "");

}


